import { List, Map, Record, Set } from 'immutable';

const SupportedCollectionsEnum = Object.freeze({
  IMMUTABLE_RECORD: '#IMMUTABLE_RECORD_69EF907DCACF4306A78F340D5665B567',
  IMMUTABLE_LIST: '#IMMUTABLE_LIST_59EC9576AEBA47F296A3252718E085E2',
  IMMUTABLE_MAP: '#IMMUTABLE_MAP_473F18C36BB64E72AA14739480CDEC51',
  IMMUTABLE_SET: '#IMMUTABLE_SET_1E9A6C0ACD5C49FDA0A2183DB94AA975',
});

const simpleTypes = ['number','string','undefined','boolean','symbol'];

export const convertToJSRecursive = (object) => {
  let jsObject;

  let goRecursive = true;
  if (simpleTypes.includes(typeof object) || object === null) {
    jsObject = object;
    goRecursive = false;
  } else if (List.isList(object)) {
    jsObject = object.toArray();
    jsObject.push(SupportedCollectionsEnum.IMMUTABLE_LIST)
  } else if (Map.isMap(object)) {
    jsObject = object.toObject();
    jsObject[SupportedCollectionsEnum.IMMUTABLE_MAP] = true;
  } else if (Record.isRecord(object)) {
    jsObject = object.toObject();
    jsObject[SupportedCollectionsEnum.IMMUTABLE_RECORD] = true;
  } else if (Set.isSet(object)) {
    jsObject = object.toArray();
    jsObject.push(SupportedCollectionsEnum.IMMUTABLE_SET);
  } else if (Array.isArray(object)) {
    jsObject = [...object];
  } else {
    jsObject = {...object};
  }
  if (goRecursive) {
    Object.keys(jsObject).forEach((key) => {
      if (typeof object[key] !== "function")
        jsObject[key] = convertToJSRecursive(jsObject[key]);
    });
  }

  return jsObject;
};

export const dehydrateImmutable = (immutable) => {
  const jsObject = convertToJSRecursive(immutable);
  const dehydrated = JSON.stringify(jsObject);
  return dehydrated;
}

export const convertToImmutableRecursive = (jsObject) => {
  let object;

  if (simpleTypes.includes(typeof jsObject) || jsObject === null) {
    object = jsObject;
  } else if (Array.isArray(jsObject)) {
    if (jsObject[jsObject.length - 1] === SupportedCollectionsEnum.IMMUTABLE_LIST) {
      jsObject.pop();
      object = List(jsObject.map(convertToImmutableRecursive));
    } else if (jsObject[jsObject.length - 1] === SupportedCollectionsEnum.IMMUTABLE_SET) {
      jsObject.pop();
      object = Set(jsObject.map(convertToImmutableRecursive));
    } else {
      object = jsObject.map(convertToImmutableRecursive);
    }
  } else {
    Object.keys(jsObject).forEach((key) => {
      jsObject[key] = convertToImmutableRecursive(jsObject[key]); // eslint-disable-line no-param-reassign
    });

    if (jsObject[SupportedCollectionsEnum.IMMUTABLE_MAP]) {
      delete jsObject[SupportedCollectionsEnum.IMMUTABLE_MAP]; // eslint-disable-line no-param-reassign
      object = Map(jsObject);
    } else if (jsObject[SupportedCollectionsEnum.IMMUTABLE_RECORD]) {
      delete jsObject[SupportedCollectionsEnum.IMMUTABLE_RECORD]; // eslint-disable-line no-param-reassign
      const Rec = Record(jsObject);
      object = new Rec();
    } else {
      object = jsObject;
    }
  }

  return object;
};

export const hydrateImmutable = (json) => {
  const jsObject = JSON.parse(json);
  const hydrated = convertToImmutableRecursive(jsObject);
  return hydrated;
}
